import {getReportParams, report} from '../../../../middleware/report';

// ===== FUNTONE REPORTS =====

export function dwhFuntoneLobbyPageDisplay({subscriber, customerName, id, ban, crmId, isExistingSubscriber}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'Funtone Lobby Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Funtone Lobby Page Displayed';
  reportParams.param1 = isExistingSubscriber || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneGenrePageDisplay({subscriber, customerName, id, ban, crmId, isExistingSubscriber, genreName}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'Funtone Lobby Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Funtone Genre Page Displayed';
  reportParams.param1 = isExistingSubscriber || '';
  reportParams.param2 = genreName || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneNewSubscriptionDownloadClick({subscriber, customerName, id, ban, crmId, isExistingSubscriber}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'New Subscription';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'New Funtone Download Clicked';
  reportParams.param1 = isExistingSubscriber || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneNewSubscriptionSuccess({subscriber, customerName, id, ban, crmId, isExistingSubscriber}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'New Subscription';
  reportParams.status = 'Completed';
  reportParams.messageText = 'New Subscription Success';
  reportParams.param1 = isExistingSubscriber || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneNewSubscriptionFailed({subscriber, customerName, id, ban, crmId, isExistingSubscriber}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'New Subscription';
  reportParams.status = 'Error';
  reportParams.messageText = 'New Subscription Failed';
  reportParams.param1 = isExistingSubscriber || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneEnterManagementPage({subscriber, customerName, id, ban, crmId, isExistingSubscriber}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'EnterManagementPage';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Enter management page';
  reportParams.param1 = isExistingSubscriber || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneSongDownloadDisplayed({subscriber, customerName, id, ban, crmId, songName}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'DownloadSong';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Song download displayed';
  reportParams.param1 = songName || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneSongDownloadSuccess({subscriber, customerName, id, ban, crmId, songName}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'DownloadSong';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Song download successful';
  reportParams.param1 = songName || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneSongDownloadFailed({subscriber, customerName, id, ban, crmId, songName}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'DownloadSong';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Song download failed';
  reportParams.param1 = songName || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneSongDelete({subscriber, customerName, id, ban, crmId, songName}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'DeleteSong';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Delete song';
  reportParams.param1 = songName || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneSongDeleteSuccess({subscriber, customerName, id, ban, crmId, songName}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'DeleteSong';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Song deletion successful';
  reportParams.param1 = songName || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneSongDeleteFailed({subscriber, customerName, id, ban, crmId, songName}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'DeleteSong';
  reportParams.status = 'Error';
  reportParams.messageText = 'Song deletion failed';
  reportParams.param1 = songName || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneChangePackage({subscriber, customerName, id, ban, crmId, packageType}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'ChangePackage';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Change package';
  reportParams.param1 = packageType || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneChangePackageSuccess({subscriber, customerName, id, ban, crmId, packageType}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'ChangePackage';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Package change successful';
  reportParams.param1 = packageType || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneChangePackageFailed({subscriber, customerName, id, ban, crmId, packageType}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'ChangePackage';
  reportParams.status = 'Error';
  reportParams.messageText = 'Package change failed';
  reportParams.param1 = packageType || '';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneChangeDefaultSong({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'ChangeDefaultSong';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Change default song';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneChangeDefaultSongSuccess({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'ChangeDefaultSong';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Default song change successful';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneChangeDefaultSongFailed({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'ChangeDefaultSong';
  reportParams.status = 'Error';
  reportParams.messageText = 'Default song change failed';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneChangePlaybackConcept({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'ChangePlaybackConcept';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Change playback concept';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneChangePlaybackConceptSuccess({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'ChangePlaybackConcept';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Playback concept change successful';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneChangePlaybackConceptFailed({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'ChangePlaybackConcept';
  reportParams.status = 'Error';
  reportParams.messageText = 'Playback concept change failed';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneAddSongToPlaylist({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'AddSongToPlaylist';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Add song to playlist';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneAddSongToPlaylistSuccess({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'AddSongToPlaylist';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Song added to playlist successfully';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneAddSongToPlaylistFailed({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'AddSongToPlaylist';
  reportParams.status = 'Error';
  reportParams.messageText = 'Failed to add song to playlist';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneRemoveSongFromPlaylist({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'RemoveSongFromPlaylist';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Remove song from playlist';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneRemoveSongFromPlaylistSuccess({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'RemoveSongFromPlaylist';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Song removed from playlist successfully';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneRemoveSongFromPlaylistFailed({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'RemoveSongFromPlaylist';
  reportParams.status = 'Error';
  reportParams.messageText = 'Failed to remove song from playlist';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneAssignSongToContact({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'AssignSongToContact';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Assign song to contact';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneAssignSongToContactSuccess({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'AssignSongToContact';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Song assigned to contact successfully';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneAssignSongToContactFailed({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'AssignSongToContact';
  reportParams.status = 'Error';
  reportParams.messageText = 'Failed to assign song to contact';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneRemoveSongFromContact({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'RemoveSongFromContact';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Remove song from contact';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneRemoveSongFromContactSuccess({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'RemoveSongFromContact';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Song removed from contact successfully';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneRemoveSongFromContactFailed({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'RemoveSongFromContact';
  reportParams.status = 'Error';
  reportParams.messageText = 'Song removal from contact failed displayed';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneSearchDisplayed({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'Search';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Search screen displayed';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneSearchResultsDisplayed({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'Search';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Search results displayed';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneNoSearchResults({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'Search';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'No search results displayed';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneChangeSongSetting({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'Changesongsetting';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Song setting change displayed';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneChangeSongSettingSuccess({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'Changesongsetting';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Song setting change success displayed';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}

export function dwhFuntoneChangeSongSettingFailed({subscriber, customerName, id, ban, crmId}) {
  let reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Funtone';
  reportParams.actionType = 'Changesongsetting';
  reportParams.status = 'Error';
  reportParams.messageText = 'Song setting change failure displayed';
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.ban = ban;
  reportParams.idNumber = id;
  reportParams.crmId = crmId;
  report(reportParams);
}